<template>
  <v-card class="ma-5">

    <v-card-item>
      <v-card-title class="text-headline-small">Dump FROM / Restore TO</v-card-title>
    </v-card-item>

    <v-card-text>
      <p class="text-title-large text-grey-darken-2 mt-4">data (dataStore)</p>
      <v-btn size="small" :block="mobile" @click="dataOfDataStore" color="primary">
        <template v-slot:prepend>
          <v-icon>mdi-download</v-icon>
        </template>download</v-btn>

      <file-input :config="{
        label: 'restore',
        size: 'small',
        destination: 'restore',
        icon: 'mdi-upload',
        file: {
            txt: true,
            json: true,
        },
        }"
        @onFileReaded="restoreData"
      />

      <p class="text-title-large text-grey-darken-2 mt-4">session (runtimeStore)</p>
      <v-btn size="small" :block="mobile" @click="sessionOfDataStore" color="primary">
        <template v-slot:prepend>
          <v-icon>mdi-download</v-icon>
        </template>download</v-btn>

      <file-input :config="{
        label: 'restore',
        size: 'small',
        destination: 'restore',
        icon: 'mdi-upload',
        file: {
          txt: true,
          json: true,
        },
      }" @onFileReaded="restoreSession" />



      <p class="text-title-large text-grey-darken-2 mt-4">userHistory (historyStore)</p>
      <v-btn size="small" :block="mobile" @click="historyOfDataStore" color="primary">
        <template v-slot:prepend>
          <v-icon>mdi-download</v-icon>
        </template>download</v-btn>

      <!-- <p class="text-title-large text-grey-darken-2 mt-4">allFiles (filesStore)</p>
      <v-btn size="small" :block="mobile" @click="filesOfFilesStore" color="primary">
        <template v-slot:prepend>
          <v-icon>mdi-download</v-icon>
        </template>download</v-btn> -->

      <!-- 
      <p class="text-title-large text-grey-darken-2 mt-4">global</p>
      <v-btn size="small" :block="mobile" color="primary" @click="" class="my-2">
        <template v-slot:prepend>
          <v-icon>mdi-download</v-icon>
        </template>
        global
      </v-btn>
      <p class="text-title-large text-grey-darken-2 mt-4">local Storage</p>
      <v-btn size="small" :block="mobile" color="primary" @click="" class="my-2">
        <template v-slot:prepend>
          <v-icon>mdi-download</v-icon>
        </template>
        local Storage
      </v-btn>

      <p class="text-title-large text-grey-darken-2 mt-4">caches</p>
      <v-btn size="small" :block="mobile" color="primary" @click="">
        <template v-slot:prepend>
          <v-icon>mdi-download</v-icon>
        </template>
        caches
      </v-btn>
       -->
    </v-card-text>
  </v-card>
</template>

<script setup>
import FileInput from '@/components/media/FileInput.vue'

import { onMounted, computed } from "vue";
import { toRaw } from "vue";


import { useDisplay } from 'vuetify'
const { mobile } = useDisplay()
// import { inject } from 'vue'
import { useDumper } from "@/service/dumper"
const dumper = useDumper()


import { useDataStore } from "@/store/data";
const dataStore = useDataStore();

import { useRuntimeStore } from "@/store/runtime";
const runtimeStore = useRuntimeStore();

import { useHistoryStore } from "@/store/history"
const historyStore = useHistoryStore()

import { useFilesStore } from "@/store/files"
const filesStore = useFilesStore()


import { useToastsStore } from '@/store/toasts';
const toastsStore = useToastsStore()



const restoreData = (file) => {
    // console.log("restoreData")
    const target = {
      obj: dataStore, 
      key: "data"
    }
    const saveCallback = dataStore.save   // dont run it here... ()
    restore(file, target, saveCallback)
}


const restoreSession = (file) => {
    // console.log("restoreSession")
    const target = {
      obj: runtimeStore, 
      key: "session"
    }
    const saveCallback = runtimeStore.saveSession   // dont run it here... ()
    restore(file, target, saveCallback)
}



const restore = (file, target, saveCallback) => {

    let content = null

    if (["application/json", "text/plain"].includes(file.mimetype)) {
        content = JSON.parse(file.content)
    }

    console.log("filePassed")
    console.log(target)
    console.log(content)

    if (content === null) {
        toastsStore.toast({
            title: `Restore`,
            text: `File non valido`,
            type: "error",
            icon: "mdi-backup-restore"
        })
        return
    }

    target.obj[target.key] = content
    console.log(target.obj[target.key])
    saveCallback()

    toastsStore.toast({
            title: `Restore`,
            text: `Restore completato, riavvio...`,
            type: "success",
            icon: "mdi-backup-restore",
            showUICountdown: true,
            duration: 5000,
            callbackOnHide: () => { window.location.reload()}

        })

}












const dataOfDataStore = async () => {
  dumper.data(toRaw({
    data: dataStore.data,
    fileName: "data_now"
  }))
}

const sessionOfDataStore = async () => {
  dumper.data(toRaw({
    data: runtimeStore.session,
    fileName: "session_now"
  }))
}

const historyOfDataStore = async () => {
  dumper.data(toRaw({
    data: historyStore.userHistory,
    fileName: "history_now"
  }))
}

const filesOfFilesStore = async () => {
  dumper.data(toRaw({
    data: await filesStore.allFiles(),
    fileName: "files_now"
  }))
}

</script>

<style scoped></style>
